import { TFunction } from 'i18next'

type DurationInput = {
  days: number
  hours: number
  minutes: number
}

export const formatDuration = (duration: DurationInput, t: TFunction<'shared'>): string => {
  if (duration.days === 0) {
    if (duration.hours === 0) {
      return t('duration.minute', { count: duration.minutes })
    }
    return t('duration.hour', { count: duration.hours })
  }

  return t('duration.day', { count: duration.days })
}
